import Vue from 'vue'
import Router from 'vue-router'
import {appRoutes} from "./modules/App/AppRoutes";

let routes = []

routes = routes.concat(
    appRoutes
)

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
